import { Concept, ConceptsByCid } from '../concept/Concept'
import { typeHasSubconcepts } from '@fusion-advantage/backcompat'
import { ConceptProposedEntities, PersistModel, model1pGr, model1ppg1rpo } from './PersistModel'

export class ConceptPersister {
	concept: Concept
	subconcepts: ConceptsByCid
	private proposedEntities: ConceptProposedEntities|null = null

	constructor(concept: Concept, subconcepts: ConceptsByCid) {
		this.concept = concept
		this.subconcepts = subconcepts
	}

	get persistModel(): PersistModel|null {
		const valueDataType = this.concept.valueDataType
		if(valueDataType === null) {
			return null
		}
		// assign default persistModel based on valueDataType
		return typeHasSubconcepts(valueDataType) ? model1ppg1rpo : model1pGr
	}

	getProposedEntities(): ConceptProposedEntities|null {
		if(this.persistModel === null) {
			return null
		}
		if(this.proposedEntities === null) {
			this.proposedEntities = this.persistModel.getProposedEntities(this.concept, this.subconcepts)
		}
		return this.proposedEntities
	}
}

export interface ConceptPersistersByCid {
	[cid: string]: ConceptPersister
}

export const getConceptPersisters = (concepts: ConceptsByCid): ConceptPersistersByCid => {
	const persisters: ConceptPersistersByCid = {}
	for(let cid in concepts) {
		let concept = concepts[cid]
		let subconcepts: ConceptsByCid = {}
		for(let subconceptCid of concept.subconcepts) {
			subconcepts[subconceptCid] = concepts[subconceptCid]
		}
		persisters[cid] = new ConceptPersister(concept, subconcepts)
	}
	return persisters
}
